import React from 'react'
import System from "../../../../../helper/system";
import Order from "@system/config/order";
import { useOrderStore } from 'src/hooks/order';
import { useDOMAttachToSystemStore } from 'src/hooks/domAttachToSystem';

const OrderInfoHeader = () => {
    const { translation: t } = System;
    const [{ order_detail }, { }, { export_order }] = useOrderStore();
    const [{ }, { system_alert_indicator }, { }] = useDOMAttachToSystemStore();

    const exportOrder = async (orderNumber, webOrderNumber) => {
        await export_order({
            OrderId: webOrderNumber,
            SalesOrderNumber: orderNumber
        })
        system_alert_indicator({
            name: 'ExportOrder',
            message: t('documentDownloadMessage'),
            type: "success"
        })
    }

    const navigateToOrderHistory = () => {
        const previousUrl = document.referrer;
        if (previousUrl?.includes('OrderDetail') || !previousUrl) {
            window.location.href = Order.getOrderRouteURL();
        } else {
            window.location.href = previousUrl;
        }
    }

    return (
        <>
            <div className="pcn-page-head header-container d-flex align-items-center justify-sm-content-between flex-wrap flex-sm-nowrap">
                <div className="page-title font-oswald font-light font-30 mb-3 mb-sm-0">{t('orderDetails')}</div>
                <div className="ms-sm-auto mb-0">
                    <ul className="d-flex justify-content-start justify-content-lg-end list-unstyled mb-0">
                        <li className="ms-sm-4 font-13 font-arial"><a className='d-flex align-items-center'
                            href={void (0)} data-toggle="modal" data-target="#EmailSales" onClick={() => {
                                System.popup('OrderDetailEmailSalesPopup', {
                                    "emailTo": order_detail?.smrEmail
                                });
                            }}><i className="fa fa-envelope me-2 text-black" aria-hidden="true"></i> {t('emailAvnet')}</a></li>
                        <li className="ms-4 font-13 font-arial"
                            onClick={() => exportOrder(order_detail?.orderHeader?.salesOrderNumber, order_detail?.orderHeader?.webOrderNumber)}>
                            <a className='d-flex align-items-center'><i className="file-export-icon me-2 text-black" aria-hidden="true"></i>{t('exportCsv')}</a></li>
                        <li className="ms-4 font-13 font-arial">
                            <a className='d-flex align-items-center' href={void (0)} onClick={() => window.print()}>
                                <i className="fa fa-print me-2 text-black"></i>{t('printPdf')}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="pcn-line-divider mb-2" />

            <div className="d-flex align-items-center mb-2">
                <a href={void (0)} className="return-to-order"
                    onClick={() => navigateToOrderHistory()}>
                    <i className='return-cart me-1'></i><span>{t('returnToOrderHistory')}</span>
                </a>
            </div>
        </>
    )
}

export default OrderInfoHeader